<ul class="system-tabs tabs">
  @for (system of systems; track system) {
  <li class="tab">
    <a
      class="tab-link"
      [routerLink]="['..', system.id, childPath]"
      [routerLinkActive]="['active-nav']"
      queryParamsHandling="merge"
      [ngClass]="{ active: activeSystemId == system.id }"
    >
      <div class="vertical">
        <div class="tab-label one-line">{{ system.name }}</div>
        <div class="one-line">
          <span class="progress space"> {{ system.numQuestionsAnswered }}/{{ system.numQuestionsTotal }} parameters</span>
          <span class="status"><app-status-badge [status]="system.status"></app-status-badge></span>
        </div>
      </div>
    </a>
  </li>
  }
</ul>
